"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var React = _interopRequireWildcard(require("react"));

var _invariant = _interopRequireDefault(require("invariant"));

var _propTypes = _interopRequireDefault(require("@insolus/prop-types"));

var _classnames = _interopRequireDefault(require("classnames"));

var _zipObject2 = _interopRequireDefault(require("lodash/zipObject"));

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

var _normalizeLabels = function _normalizeLabels(labels) {
  var _labels = {
    left: null,
    right: null
  };

  if (labels == null) {
    return _labels;
  }

  if (Array.isArray(labels)) {
    (0, _invariant.default)(labels.length === 2, "Les labels pass\xE9s sous forme de tableau doivent \xEAtre exactement deux " + "(un pour la gauche, un pour la droite).");
    return (0, _zipObject2.default)(['left', 'right'], labels);
  }

  return _objectSpread(_objectSpread({}, _labels), labels);
};

var Switch = function (_React$Component) {
  (0, _inherits2.default)(Switch, _React$Component);

  var _super = _createSuper(Switch);

  function Switch(props) {
    var _this;

    (0, _classCallCheck2.default)(this, Switch);
    _this = _super.call(this, props);

    _this.handleChange = function (e) {
      var checked = e.currentTarget.checked;

      _this._triggerCheckChange(checked);
    };

    _this.handleLabelClick = function (side) {
      return function () {
        var oldCheckedState = _this.state.checked;
        var newCheckedState;

        if (_this._isSimpleLabelled()) {
          newCheckedState = !oldCheckedState;
        } else {
          newCheckedState = side === 'right';
        }

        if (newCheckedState === oldCheckedState) {
          return;
        }

        _this._triggerCheckChange(newCheckedState);
      };
    };

    var _checked = !!props.defaultChecked;

    if (props.checked !== undefined) {
      _checked = !!props.checked;
    }

    _this.state = {
      checked: _checked
    };
    return _this;
  }

  (0, _createClass2.default)(Switch, [{
    key: "_triggerCheckChange",
    value: function _triggerCheckChange(checked) {
      var _this2 = this;

      var disabled = this.props.disabled;

      if (disabled) {
        return;
      }

      var _next = function _next() {
        if (_this2.props.onChange) {
          _this2.props.onChange(checked);
        }
      };

      if (this.props.checked === undefined) {
        this.setState({
          checked: checked
        }, _next);
      } else {
        _next();
      }
    }
  }, {
    key: "_isSimpleLabelled",
    value: function _isSimpleLabelled() {
      var labels = this._getLabels();

      if (!labels.right && !labels.left) {
        return false;
      }

      return !labels.right || !labels.left;
    }
  }, {
    key: "_getLabels",
    value: function _getLabels() {
      var _this$props = this.props,
          label = _this$props.label,
          labels = _this$props.labels;

      if (labels) {
        return _normalizeLabels(labels);
      }

      return {
        left: null,
        right: label
      };
    }
  }, {
    key: "renderInput",
    value: function renderInput() {
      var checked = this.state.checked;
      var _this$props2 = this.props,
          name = _this$props2.name,
          disabled = _this$props2.disabled,
          value = _this$props2.value;

      if (disabled) {
        return null;
      }

      return React.createElement("input", {
        type: "checkbox",
        name: name,
        value: value,
        checked: checked,
        className: "Switch__native-input",
        onChange: this.handleChange
      });
    }
  }, {
    key: "render",
    value: function render() {
      var checked = this.state.checked;
      var _this$props3 = this.props,
          disabled = _this$props3.disabled,
          className = _this$props3.className;

      var labels = this._getLabels();

      var _className = (0, _classnames.default)(className, 'Switch', {
        'Switch--checked': checked,
        'Switch--disabled': disabled
      });

      return React.createElement("span", {
        className: _className
      }, labels.left && React.createElement("button", {
        type: "button",
        className: "Switch__label Switch__label--left",
        onClick: this.handleLabelClick('left')
      }, labels.left), React.createElement("span", {
        className: "Switch__input"
      }, this.renderInput()), labels.right && React.createElement("button", {
        type: "button",
        className: "Switch__label Switch__label--right",
        onClick: this.handleLabelClick('right')
      }, labels.right));
    }
  }], [{
    key: "getDerivedStateFromProps",
    value: function getDerivedStateFromProps(nextProps, prevState) {
      if (nextProps.checked !== undefined && prevState.checked !== nextProps.checked) {
        return {
          checked: !!nextProps.checked
        };
      }

      return null;
    }
  }]);
  return Switch;
}(React.Component);

Switch.isFormControl = true;
Switch.defaultProps = {
  name: undefined,
  checked: undefined,
  defaultChecked: false,
  disabled: false,
  label: undefined,
  labels: undefined,
  value: undefined,
  onChange: undefined,
  className: undefined
};
var _default = Switch;
exports.default = _default;